import React, {createContext, useReducer} from 'react'
import {PrintLabelReducer} from "../reducers/PrintLabelReducer";

export const PrintLabelContext = createContext();

const PrintLabelContextProvider = (props) => {

    const initialState = {
        isLoading: false,
        requestCompleted: false,
        errorOccurred: false,
        errorMessage: ""
    };

    const [printLabelModel, printLabelDispatch] = useReducer(PrintLabelReducer, initialState)
    return (
        <PrintLabelContext.Provider value={{printLabelModel, printLabelDispatch}}>
            {props.children}
        </PrintLabelContext.Provider>
    )
}

export default PrintLabelContextProvider



// WEBPACK FOOTER //
// ./src/components/labelSheet/context/PrintLabelContext.js